import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const storiesCompletionRateConfig = {
    name: 'chart.instagram.stories.completion_rate',
    id: 'new_completed_rate',
    icon: {
        name: 'completion-rate',
        style: colors.green
    },
    data_format: KPI_VALUE_PERCENT,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_50,
    type: 'kpi',
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
